export const termsPage = () =>
  import("./TermsPage").then((m) => ({ Component: m.TermsPage }));
